import { cn } from '@nexelem/utils';
import { useDayPicker, DropdownProps } from 'react-day-picker';
import { setMonth } from 'date-fns';
import { Button } from '../Button';

export const MonthsDropdown = (props: DropdownProps) => {
  const { goToMonth, months, dayPickerProps } = useDayPicker();

  const isFirst = props.value === months[0].date.getMonth();
  const monthDiff = isFirst ? 1 : -1;
  const onChangeDiff = isFirst ? 0 : -1;

  return (
    <div className="grid grid-cols-3 gap-1 py-1">
      {props.options?.map((option) => {
        const monthAction = setMonth(months[0].date, option.value + onChangeDiff);
        return (
          <Button
            disabled={option.disabled}
            key={option.label}
            variant="text"
            className={cn(
              'h-9 w-20 rounded-full text-s16 capitalize',
              props.value === option.value && 'border border-border-brand! bg-surface-focus-lighter text-text-brand!',
              Number(props.value) + monthDiff === option.value &&
                dayPickerProps.numberOfMonths !== 1 &&
                'border border-border-focus-lighter bg-surface-focus-lighter text-s16-sb text-text-focus',
            )}
            onClick={() => goToMonth(monthAction)}
          >
            {option.label.slice(0, 3)}
          </Button>
        );
      })}
    </div>
  );
};
